<script setup>
// NOTICE: KAPTION-INTEGRATION - Account-wide opt-in for alerts to past participants.
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();
const isEnabled = ref(false);

watch(
  currentAccount,
  () => {
    isEnabled.value =
      currentAccount.value?.settings?.participant_notifications_enabled ===
      true;
  },
  { deep: true, immediate: true }
);

const toggle = async () => {
  try {
    await updateAccount({ participant_notifications_enabled: isEnabled.value });
    useAlert(
      t('GENERAL_SETTINGS.FORM.KAPTION_PARTICIPANT_NOTIFICATIONS.API.SUCCESS')
    );
  } catch (error) {
    isEnabled.value = !isEnabled.value;
    useAlert(
      t('GENERAL_SETTINGS.FORM.KAPTION_PARTICIPANT_NOTIFICATIONS.API.ERROR')
    );
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.KAPTION_PARTICIPANT_NOTIFICATIONS.TITLE')"
    :description="
      t('GENERAL_SETTINGS.FORM.KAPTION_PARTICIPANT_NOTIFICATIONS.NOTE')
    "
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggle" />
      </div>
    </template>
  </SectionLayout>
</template>
